import { list as statusList } from '@/configs/statuses'
import { gceSpecialistCAUserType } from '@/configs/constants'

export const certificationAgencyRoles = [
  'Director certification',
  'Auditor certification',
  'universal_role_of_ca',
  gceSpecialistCAUserType,
]
export const laboratoryRoles = [
  'Director laboratory',
  'Expert laboratory',
  'Section cheif laboratory',
  'Manager laboratory',
  'gce_specialist',
  'universal_role_of_ml',
]

export const statementFilterFields = [
  { key: 'number', label: 'Номер', type: 'number' },
  { key: 'created_at_range', label: 'Дата заявки', type: 'date' },
  { key: 'vehicle_mark_name', label: 'Марка', type: 'text' },
  { key: 'vin_code', label: 'VIN', type: 'text' },
  { key: 'client_full_name', label: 'Клієнт', type: 'text' },
  {
    key: 'transferred_to_transport_service',
    label: 'Сертифікат в ДСБТ',
    type: 'boolean',
    options: [
      { value: true, text: 'Передано' },
      { value: false, text: 'Не переданий' },
    ],
  },
  { key: 'vehicle_condition', label: 'Тип сертифікації', type: 'multi', directory: 'certificationTypes' },
  { key: 'status_document', label: 'Статус', type: 'multi', numeric: true, directory: 'statuses' },
  {
    key: 'laboratory',
    label: 'Назва ВЛ',
    type: 'multi',
    role: 'OC',
    directory: 'laboratories',
    numeric: true,
    searchable: true,
  },
  {
    key: 'laboratory_branch_office',
    label: 'Номер дільниці',
    type: 'multi',
    directory: 'branches',
    numeric: true,
    searchable: true,
  },
]

export const statementSortFields = {
  number: 'number',
  markWithModel: 'vehicle_mark_name',
  vin_code: 'vin_code',
  clientAbbr: 'client_full_name',
  vehicle_condition: 'vehicle_condition',
  created_at: 'created_at',
  laboratory_name: 'laboratory_name',
  laboratory_branch_office_number: 'laboratory_branch_office_number',
  status_statement: 'status_document',
  transferred_to_transport_service: 'transferred_to_transport_service',
}

export const statementStatusIds = [
  // statusList.statementCreateByLaboratory,
  statusList.statementWaitForClientSignature,
  statusList.statementWaitForCategoryChoices,
  statusList.statementWaitForDecision,
  statusList.statementReject,
  statusList.statementAllowedForInspection,
  statusList.statementDecisionWaitSignature,
  statusList.statementInProgressInspection,
  statusList.statementWaitSignatureAuditor,
  statusList.statementCertificateInProgress,
  statusList.statementCertificateIssued,
  statusList.statementCertificateNotIssued,
  statusList.statementWaitForLaboratory,
  statusList.statementWaitSignatureManager,
  statusList.statementDecisionWaitForDirectorSignature,
  statusList.statementDecisionWaitForSignatureExpert,
  statusList.statementDecisionWaitForSignatureChief,
  statusList.statementDecisionWaitForSignatureCertAuditor,
  statusList.statementDecisionWaitForSignatureCertDirector,
  statusList.statementWaitSignatureCertDirector,
  statusList.identificationActWaitDecisionAuditor,
  statusList.identificationActWaitSignatureForAuditor,
  statusList.identificationActWaitSignatureForManager,
  statusList.statementWaitForCertificationAgency,
  statusList.statementWaitReprocessing,
  statusList.statementWaitingAddInspectionProtocolNumber,
]
